import { memo } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzChip, BzModalBody, BzModalFooter, BzModalHeader } from "../../../../components";
import OrderPlacedSuccess from './OrderPlacedSuccess';
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../../../redux/actions/modals";

const ConfirmBuyOrder = ({ nfoDetails }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const handleOnConfirmBuyOrder = () => {
        dispatch(handleModal([{ 'CONFIRM_BUY_ORDER': false }, { 'ORDER_PLACE_SUCCEFULL': true }]));

    };
    const hanldeOnGoBack = () => {
        dispatch(handleModal([{ 'CONFIRM_BUY_ORDER': false }, { "PLACE_NFO_ORDER": true }]));

    };
    const handleClose = () => {
        dispatch(handleModal([{ "CONFIRM_BUY_ORDER": false }]));
    };
    return (
        <>
            <BzModal show={modals['CONFIRM_BUY_ORDER']} onHide={handleClose} centered>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size5 color-text'>Confirm Your <span className='color-positive'>Buy</span> Order</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0 p-3'>
                        <Row className='g-0 mb-2'>
                            <Col>
                                <div className='font-medium font-size5 color-text'>{nfoDetails?.fundName}</div>
                                <div className='chips-wrap flex-wrap'>
                                    {nfoDetails?.fundcategory?.map(category =>
                                        <BzChip className='chips primary-chip me-2 mb-2'>{category}</BzChip>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mt-3'>
                            <Col>
                                <div className='justify-content-between d-flex pb-2'>
                                    <div className='font-regular font-size4 color-subtext'>Order Type</div>
                                    <div className='font-regular font-size4 color-text'>{nfoDetails?.orderType}</div>
                                </div>
                                <div className='justify-content-between d-flex pb-2'>
                                    <div className='font-regular font-size4 color-subtext'>Price</div>
                                    <div className='font-regular font-size4 color-text'>{nfoDetails?.price}</div>
                                </div>
                                <div className='justify-content-between d-flex pb-2'>
                                    <div className='font-regular font-size4 color-subtext'>Transaction Type</div>
                                    <div className='font-regular font-size4 color-text'>{nfoDetails?.transactionType}</div>
                                </div>
                                <div className='justify-content-between d-flex pb-2'>
                                    <div className='font-regular font-size4 color-subtext'>Folio Number</div>
                                    <div className='font-regular font-size4 color-text'>{nfoDetails?.folioNumber}</div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <BzButton className='btn btn-md btn-outline btn-block d-flex justify-content-center align-items-center' onClick={hanldeOnGoBack}>
                                    <div className='icon-12 icon-backward-arrow icon-primary me-2'></div>
                                    <span>Go Back</span>
                                </BzButton>
                                <BzButton className='btn btn-md btn-primary btn-block ms-3' onClick={handleOnConfirmBuyOrder}>Confirm</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            <OrderPlacedSuccess />
        </>

    );
};

export default memo(ConfirmBuyOrder);